var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#52df84",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,30c-3.764,0-7.317,1.581-9.75,4.338c-0.365,0.415-0.326,1.047,0.088,1.412c0.415,0.366,1.045,0.327,1.412-0.088 C37.803,33.335,40.811,32,44,32c6.065,0,11,4.935,11,11s-4.935,11-11,11c-4.992,0-9.407-3.367-10.741-8H38v-2h-8v8h2v-3.663 C34.093,52.867,38.781,56,44,56c7.168,0,13-5.832,13-13S51.168,30,44,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,25c0-0.342-0.175-0.66-0.463-0.844l-11-7c-0.31-0.195-0.698-0.208-1.019-0.033C24.199,17.299,24,17.635,24,18v14 c0,0.365,0.199,0.701,0.519,0.877C24.669,32.959,24.835,33,25,33c0.187,0,0.373-0.053,0.537-0.156l11-7 C36.825,25.66,37,25.342,37,25z M26,30.179V19.821L34.138,25L26,30.179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,2H47H11H1C0.447,2,0,2.447,0,3v11v11v11v11c0,0.553,0.447,1,1,1h10h13c0.553,0,1-0.447,1-1s-0.447-1-1-1H12V36V25V14V4 h34v10v11c0,0.553,0.447,1,1,1h9v7c0,0.553,0.447,1,1,1s1-0.447,1-1v-8V14V3C58,2.447,57.553,2,57,2z M2,26h8v9H2V26z M10,24H2v-9 h8V24z M2,46v-9h8v9H2z M10,13H2V4h8V13z M56,4v9h-8V4H56z M48,24v-9h8v9H48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTranslation);
export default __webpack_public_path__ + "static/media/video-translation.724721d4347042447bd213dd9a0cdd70.svg";
export { ForwardRef as ReactComponent };